const messages = {
  ['pt-BR']: {
    translations: {
      auth: {
        signIn: 'Entrar',
        signUp: 'Registrar',
        forgotPassword: 'Esqueceu a senha?',
      },
      login: {
        welcome: 'Bem-vindo de volta!',
        username: 'Email',
        password: 'Senha',
      },
      firebase: {
        successOnGetToken: 'Notificações configuradas com sucesso.',
        dontHaveServiceWorker: 'Não foi possível obter a autorização para você receber notificações.',
        errorOnGetToken:
          'Ocorreu um erro ao obter a autorização para você receber notificações, por favor, tente novamente.',
        requestPermission:
          'Não foi possível obter a autorização para enviar notificações, por favor, habilite a permissão para que as notificações funcionem corretamente.',
      },
      laboratory: {
        modal: {
          title: 'Alerta',
          message: 'Seu navegador não é compatível com a API gráfica "WebGL 2.0" necessária para este conteúdo, dessa forma, não é possível exibir a experiência do laboratório no seu navegador.',
          okButton: 'Voltar',
        },
      },
      live: {
        isPlaying: 'Auditório / Ao Vivo',
        isNextLive: 'Auditório / Próxima Live',
        isLastLive: 'Auditório / Live Anterior',
        isUnknown: 'Auditório / Desconhecida',
        past: 'Lives Anteriores',
        future: 'Lives Futuras',
        new: 'Novo',
        livenow: 'AO VIVO AGORA',
        liveNext: 'PRÓXIMA LIVE',
        loadMore: 'Carregar mais',
        scheduled: 'Programado para',
        leaveFeedback: 'Deixe seu feedback',
        successFeedback: 'Feedback enviado',
      },
      tracks: {
        description:
          'Após visualizar todo material necessário você ira realizar um Quiz, responda corretamente para ganhar pontos!',
        slides: 'Módulo',
        quiz: 'Responder Quiz',
        youNeedWatchVideo: 'Você precisa assistir ao menos 50% do vídeo para passar para a próxima etapa!',
        mediaImageAlt: 'A mídia da imagem da trilha.',
        downloadSoftware: 'Baixar Software',
        materialUrl: 'Baixar Material',
      },
      modals: {
        levelUp: {
          title: 'SUBIU DE NÍVEL!',
          continue: 'Continuar',
          level: 'Nível',
          yourLevel: 'Você está agora no',
        },
        reward: {
          continue: 'Continuar',
          received: 'Você recebeu a seguinte experiência',
          wrong: 'Resposta errada',
          points: 'pontos',
        },
        profile: {
          progressTitle: 'SEU PROGRESSO NAS TRILHAS',
          downloadCertificate: 'Baixar certificado',
        },
        notifications: {
          pending: 'notificações pendentes',
          seeAll: 'Ver todas',
          title: 'Notificações',
          loadMore: 'Carregar mais',
        },
        cards: {
          title: 'Cartas',
          ready: 'Pronto',
          back: 'Voltar',
          cardPlaceholderAlt: 'A posição onde a carta irá ficar.',
          rewardIconPlaceholderAlt: 'A imagem da recompensa de certo ou errado.',
          rightAnswer: 'ACERTOU!',
          wrongAnswer: 'ERROU!',
        },
        roulette: {
          title: 'ROLETA',
          rouletteWheelBackAlt: 'A parte de trás da roleta.',
          rouletteWheelFrontAlt: 'A parte da frente da roleta.',
          rouletteWheelMarkerAlt: 'A parte que aponta qual opção foi selecionada.',
          rouletteWheelBotAlt: 'Clique aqui para girar a roleta.',
          rouletteWheelStandAlt: 'A base de suporte para a roleta.',
        },
        places: {
          materialUrl: 'Material',
          mediaImageAlt: 'A mídia da imagem do lugar.',
        },
        tracks: {
          reward: 'Recompensa',
        },
        feedbacks: {
          title: 'Feedback',
          ratingLabel: 'Que nota você atribui a este conteúdo?',
          contactLabel: 'Você gostaria de receber um contato para saber mais?',
          observationsLabel:
            'Caso você tenha algum comentário ou sugestão de novos temas para abordarmos, informe aqui.',
          observationsPlaceholder: 'Digite sua observação',
          sendButton: 'Enviar',
        },
        finishedTrack: {
          title: 'Parabéns!',
          congratulations:
            'Você terminou com sucesso essa trilha, agora você pode obter o certificado entrando no seu perfil ou nos dar um feedback do que achou dessa experiência.',
          giveFeedback: 'Deixe seu feedback',
          openProfile: 'Abrir perfil',
          back: 'Voltar',
          lab: 'Ir ao Laboratório',
        },
        lounge: {
          title: 'Lounge',
        },
        doubt: {
          title: 'Dúvidas',
          description: 'Você ainda tem dúvidas? Se necessário, entre em contato conosco ou se preferir, clique novamente no botão de tutorial para você passar pelo tutorial novamente para saber como usar corretamente a plataforma.',
          support: 'Entre em contato',
          tutorial: 'Fazer novamente o tutorial',
          back: 'Voltar',
        },
      },
      ranking: {
        loadMore: 'Carregar mais',
        rules: 'Regras',
        guide: '/assets/documents/Regras ranking Neles Experience Days.pdf',
        finished: 'Ranking encerrado, conheça os vencedores em 1º, 2º e 3º lugar',
      },
      places: {
        title: 'Equipamentos',
        materials: 'Materiais',
        mediaImageAlt: 'A mídia da imagem de equipamento.',
      },
      register: {
        welcome: 'Bem-vindo, vamos criar sua conta!',
        username: 'Nome',
        lastName: 'Sobrenome',
        email: 'E-mail',
        password: 'Senha',
        enterprise: 'Empresa',
        industry: 'Industria',
        language: 'Linguagem',
        country: 'País',
        department: 'Departamento',
        send: 'Continuar',
        next: 'Próximo',
        back: 'Voltar',
        terms:
          'Ao clicar no botão “Continuar”, você concorda em receber comunicações da Neles e de nossos parceiros de serviço sobre serviços, promoções e eventos que acreditamos interessar a você.',
        industries: {
          chemistry: 'Química',
          energy: 'Energia',
          gasProcessing: 'Processamento de Gás e GNL',
          industrialGas: 'Gás industrial',
          processingOfMinerals: 'Mineração e processamento de minerais',
          transportPipe: 'Tubulação de transporte',
          paperBioProductsAndCellulose: 'Celulose, Papel e Bioprodutos',
          refinery: 'Refinaria',
          others: 'Outras indústrias de processo',
        },
        departments: {
          projectEngineering: 'Engenharia de projetos',
          executiveManagement: 'Gerência executiva',
          maintenance: 'Manutenção',
          processEngineering: 'Engenharia de processo',
          control: 'Controle',
          production: 'Produção',
          supplies: 'Suprimentos',
          students: 'Estudante',
          academy: 'Acadêmico',
          sellsAndMarketing: 'Vendas e Marketing',
          others: 'Outros',
        },
      },
      buttons: {
        login: 'Entrar',
        register: 'Continuar',
      },
      menu: {
        map: 'Mapa',
        auditorium: 'Auditório',
        doubts: 'Dúvidas',
        lives: {
          future: 'Encontros Futuros',
          latest: 'Encontros Anteriores',
          now: 'Live',
        },
        training: {
          title: 'Treinamento',
          lab: 'Laboratório',
        },
        lounge: 'Agendar Reunião',
        notifications: 'Notificações',
        configurations: 'Configurações',
        loading: 'Carregando Trilhas...',
        alreadyFinishedTrack: 'Você completou a trilha, agora você pode baixar o seu certificado!',
      },
      error: {
        error: 'Oops...',
        success: 'Sucesso!',
        cannotSyncUser: 'Ocorreu um erro ao sincronizar as informações do usuário.',
        cannotUpdateUser: 'Não foi possível atualizar as informações do usuário.',
        cannotCreateUser: 'Não foi possível realizar a criação do usuário, por favor, tente novamente.',
        cannotGetUserInfo: 'Não foi possível obter as informações do seu usuário, por favor, tente novamente.',
        cannotLogin: 'Seu e-mail ou senha não estão corretos.',
        defaultMessage: 'Desculpe, ocorreu um erro inesperado.',
        cannotSentEmail: 'Não foi possível enviar o e-mail de recuperação.',
        cannotResetPassword: 'Não foi possível resetar a sua senha.',
      },
      config: {
        title: 'Configurações',
        sound: {
          title: 'Volume do som',
          withoutSound: 'Sem Som',
          lower: 'Baixo',
          normal: 'Normal',
          medium: 'Médio',
          high: 'Alto',
        },
        soundOff: 'O ícone do som mutado.',
        soundOn: 'O ícone do som ligado.',
        interface: {
          title: 'Escala de interface',
          tiny: 'Menor',
          little: 'Pequeno',
          default: 'Padrão',
          great: 'Grande',
        },
        language: 'Idioma geral',
        editProfile: 'Editar Perfil',
        credits: 'Créditos',
        logout: 'Deslogar',
        profile: {
          title: 'EDITAR PERFIL',
          namePlaceholder: 'Nome',
          save: 'SALVAR',
          successMessage: 'O seu usuário foi atualizado com sucesso!',
        },
      },
      tour: {
        step0: 'Bem-Vindo ao Neles Experience Days! Vamos lá!',
        step1: 'Aqui você pode a próxima live a ser transmitida.',
        step2: 'Através do Lounge você pode entrar em contato com a Neles.',
        step3: 'Selecione uma trilha para assistir os módulos e tirar seu certificado.',
        step4: 'No mapa você pode pode ver as trilhas, lugares, lives e lounge.',
        step5: 'No auditório você tem acesso às lives passadas, ao vivo e futuras.',
        step6: 'No treinamento você tem acesso às trilhas e ao laboratório.',
        step7: 'Aqui você pode checar o ranking dos usuários com mais pontos!',
        step8: 'Aqui você pode entrar em contato com a Neles.',
        step9: 'Aqui você pode checar as notificações da Neles para você!',
        step10: 'Na aba de configurações você pode ajustar definições do sistema.',
        done: 'Entendido!',
      },
      forgot: {
        welcome: 'Resetar a Senha pelo E-mail',
        emailCouldNotBeSent: 'Ocorreu um problema e o e-mail não foi enviado, por favor, tente novamente.',
        emailWasSentSuccess: 'E-mail de recuperação enviado com sucesso!',
        email: 'E-mail',
        sent: 'Enviar',
      },
      reset: {
        welcome: 'Resetar a Senha',
        success: 'A sua senha foi resetada com sucesso!',
        password: 'Digite a nova senha',
        sent: 'Enviar',
      },
    },
  },
};

export { messages };
